import React, { useEffect, useState, useCallback } from "react";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import Wrapper from "../Helpers/Wrapper";
import ModalOfficerInfo from "../components/ModalOfficerInfo";


const Officers = () => {
  const [htmlFileString, setHtmlFileString] = useState();
  const [showOffModal, setShowOffModal] = useState();
  const [modOffEmal, setModOffEmal] = useState("");
  const [officerName, setOfficerName] = useState("");

  const fetchHtml = useCallback(async () => {
    setHtmlFileString(
      await (
        await fetch(`/staticData/GeneralConfig.json`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
      ).json()
    );

  }, []);

  // const fetchHtml = useCallback(async () => {
  //   const rawResponse = await fetch(`/officerEdit.php`, {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "application/json",
  //       "Access-Control-Allow-Credentials": "true",
  //     },
  //   });
  //   const content = await rawResponse.text();
  //   var officersData = JSON.parse(content);
  //   console.log(officersData);
  //   // setHtmlFileString(
  //   //   await (
  //   //     await fetch(`/officerEdit.php`)
  //   //   ).json()
  //   // );
  //   // console.log(htmlFileString);


  // });

  useEffect(() => {
    fetchHtml();
  }, [fetchHtml]);

  useEffect(() => {
    if(showOffModal){
      // console.log("Showing modal");
      document.body.style.overflow = 'hidden'

    }
    if(!showOffModal){
      // console.log("Hiding modal");
      document.body.style.overflow = 'auto'
    }
  }, [showOffModal])

  const handeClick = (event) => {
    // console.log("htmlFileString: ", JSON.stringify(htmlFileString));
    // console.log("Clicked: ", event.target.textContent);
    if(event.target.textContent.includes("/")){
      // console.log('have 2 names, need to do more');
      let namesArray = event.target.textContent.split('/');
      // console.log("Name 1: ", namesArray[0]);
      // console.log("Name 2: ", namesArray[1]);
      setModOffEmal(htmlFileString["emails"][namesArray[0].trim()]["email"] + " / " + htmlFileString["emails"][namesArray[1].trim()]["email"])
    }else {

      setModOffEmal(htmlFileString["emails"][event.target.textContent]["email"])
    }
    setOfficerName(event.target.textContent)
    setShowOffModal(true);
  };

  const hideOffModal = () => {
    setShowOffModal(false);
  }

  const genNameLink = (element) => {
    // console.log("Got: ", element);
    if(element === "TBD"){
      return(<>{element}</>)
    }if(element === "TBA"){
      return(<>{element}</>)
    }else {
      return(<a href="#" onClick={handeClick}>{element}</a>)
    }
  }

  return (
    <Wrapper>
    <Accordion defaultActiveKey={["0", "1"]} alwaysOpen>
      <Accordion.Item eventKey="0">
        <Accordion.Header>
          <strong>Elected Officers</strong>
        </Accordion.Header>
        <Accordion.Body>
          {htmlFileString ? (
            <Table responsive="md">
              <tbody>
                {htmlFileString.officers.map((el, index) => (
                  <tr key={index}>
                    <td style={{width: '45%', textAlign:"right"}}>{el[0]}</td>
                    <td style={{width: '10%', textAlign:"right"}}></td>
                    <td syle={{width: '45%',textAlign:"left"}}>
                      {genNameLink(el[1])}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <Wrapper>
              <strong>LOADING... Please wait</strong>
            </Wrapper>
          )}
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header>
          <strong>Committees</strong>
        </Accordion.Header>
        <Accordion.Body>
          {htmlFileString ? (
            <Table responsive="md">
              <tbody>
                {htmlFileString.committees.map((el, index) => (
                  <tr key={index}>
                    <td style={{width: '45%', textAlign:"right"}}>{el[0]}</td>
                    <td style={{width: '10%', textAlign:"right"}}></td>
                    <td syle={{width: '45%',textAlign:"left"}} onClick={handeClick}>
                      {genNameLink(el[1])}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <Wrapper>
              <strong>LOADING... Please wait</strong>
            </Wrapper>
          )}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
    <ModalOfficerInfo 
      show={showOffModal} 
      hide={hideOffModal} 
      officerEmail={modOffEmal} 
      officerName={officerName}
    />
    </Wrapper>
  );
};

export default Officers;
